import { Button, ButtonSize, Intent, Shape } from '@axieinfinity/matcha'

export type TConnectProps = {
  className?: string
  disabled?: boolean
  connected?: boolean
  onClick?: () => void
}

export const Connect: React.FC<TConnectProps> = props => {
  const { connected, disabled, className, onClick } = props

  return (
    <Button
      intent={Intent.Default}
      shape={Shape.Default}
      disabled={disabled}
      size={ButtonSize.Small}
      onClick={onClick}
      className={className}
      text={connected ? 'Unlink' : 'Link'}
    />
  )
}
